// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"questionnaire-double"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 3V17.5L5.5 15H19V3H2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.5 7.5C8.5 6.39543 9.39543 5.5 10.5 5.5C11.6046 5.5 12.5 6.39543 12.5 7.5C12.5 9.5 10.5034 9.52778 10.5034 9.75M10.5 12.5H10.5039V12.5039H10.5V12.5ZM2 17.5V3H19V15H5.5L2 17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22.5 4.5V21L19 18.5H7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const QuestionnaireDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'questionnaire-double',
    ref,
    icon: element,
  },
));

QuestionnaireDoubleIcon.displayName = 'QuestionnaireDoubleIcon';

export default QuestionnaireDoubleIcon;
